<template>
  <header class="header">
    <!-- Logo区域 -->
    <div class="header-logo">
      <img :src="sysbaseinfo.logoUrl" alt="logo" />
    </div>

    <!-- 导航菜单 -->
    <nav class="header-nav">
      <ul class="nav-list">
        <li v-for="(item, index) in menuData"
            :key="index"
            class="nav-item"
            @mouseenter="!isMobile && enter(index, item)"
            @mouseleave="!isMobile && leave"
            @click="handleItemClick(index, item)">
          <a href="#"
             class="nav-link"
             :class="{'active': activeItem === item}">
            {{ item.name }}
          </a>

          <!-- 下拉菜单 - 核心产品 -->
          <div v-if="menuChild.length && nowItem.categoryCode === 'hxcp' && nowItem === item"
               class="dropdown-menu product-menu"
               @mouseleave="!isMobile && leaves"
               @click.stop>
            <div class="dropdown-content">
              <div v-for="(category, idx) in menuChild"
                   :key="idx"
                   class="menu-category">
                <h3 class="category-title">{{ category.name }}</h3>
                <ul class="category-list">
                  <li v-for="(subItem, subIdx) in category.childNode"
                      :key="subIdx"
                      class="category-item">
                    <a @click.stop="childLinkTo(subItem)"
                       href="javascript:"
                       class="category-link">
                      {{ subItem.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 下拉菜单 - 解决方案 -->
          <div v-if="menuChild.length && nowItem.categoryCode === 'jjfa' && nowItem === item"
               class="dropdown-menu solution-menu"
               @mouseleave="!isMobile && leaves"
               @click.stop>
            <div class="dropdown-content">
              <div class="menu-category">
                <h3 class="category-title">解决方案</h3>
                <ul class="category-list">
                  <li v-for="(solution, idx) in menuChild"
                      :key="idx"
                      class="category-item">
                    <a @click.stop="childLinkToSolution(solution)"
                       href="javascript:"
                       class="category-link">
                      {{ solution.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>

    <!-- 点击其他区域关闭下拉菜单 -->
    <div v-if="showDropdown" class="overlay" @click="closeAllDropdowns"></div>
  </header>
</template>

<script>
// import './header.css'
export default {
  name: 'MHeader',
  data() {
    return {
      show: 0,
      msg: '',
      menuItem: {},
      menuData: [],
      menuChild: [],
      nowItem: {},
      sysbaseinfo: {},
      isMobile: false,
      activeItem: null,
      showDropdown: false
    };
  },
  computed: {
    menuList() {
      return this.$store.getters.menuList;
    },
  },
  methods: {
    // 处理菜单项点击
    handleItemClick(index, item) {
      // 如果是核心产品或解决方案
      if (item.categoryCode === 'hxcp' || item.categoryCode === 'jjfa') {
        // 移动端处理
        if (this.isMobile) {
          // 如果点击的是当前激活的菜单项，则关闭它
          if (this.activeItem === item) {
            this.closeAllDropdowns();
          } else {
            // 打开新的下拉菜单
            this.closeAllDropdowns(); // 先关闭其他菜单
            this.activeItem = item;
            this.nowItem = item;
            this.enter(index, item);
            this.showDropdown = true;
          }
        } else {
          // PC端直接调用enter方法
          this.enter(index, item);
        }
        return;
      }

      // 其他菜单项正常跳转
      this.linkTo(item);
    },

    // 关闭所有下拉菜单
    closeAllDropdowns() {
      this.activeItem = null;
      this.nowItem = {};
      this.menuChild = [];
      this.showDropdown = false;
      this.show = 0;
    },

    linkTo(item) {
      sessionStorage.setItem('categoryId', item.id);
      sessionStorage.setItem('topicId', item.topicId);
      if (item.name !== '核心产品' && item.name !== '解决方案') {
        if (item.name === '首页') {
          this.$router.push({
            name: 'hom1e'
          });
          setTimeout(() => {
            let params = {
              categoryId: item.id,
              topicId: item.topicId,
            };
            this.$router.push({
              name: 'home',
              params: params,
            });
          }, 1);
          // console.log('home');
        } else if (item.name === '关于我们') {
          let params = {
            categoryId: item.id,
            topicId: item.topicId,
          };
          this.$router.push({
            name: 'abou1t',
            params: params,
          });
          setTimeout(() => {
            let params = {
              categoryId: item.id,
              topicId: item.topicId,
            };
            this.$router.push({
              name: 'about',
              params: params,
            });
          }, 1);
        } else if (item.name === '行业新闻') {
          sessionStorage.setItem('categoryId', 2);
          let params = {
            categoryId: item.id,
            topicId: item.topicId,
          };
          this.$router.push({
            name: 'new1s',
            params: params,
          });
          setTimeout(() => {
            let params = {
              categoryId: item.id,
              topicId: item.topicId,
            };
            this.$router.push({
              name: 'news',
              params: params,
            });
          }, 1);
        } else if (item.name === '信息技术') {
          this.$router.push({
            name: 'new1s'
          });
          setTimeout(() => {
            let params = {
              categoryId: item.id,
              topicId: item.topicId,
            };
            this.$router.push({
              name: 'technology',
              params: params,
            });
          }, 1);
        } else if (item.name === '人力资源') {
          this.$router.push({
            name: 'new1s'
          });
          setTimeout(() => {
            let params = {
              categoryId: item.id,
              topicId: item.topicId,
            };
            this.$router.push({
              name: 'resources',
              params: params,
            });
          }, 1);
        }
      }
    },
    childLinkTo(item) {
      sessionStorage.setItem('categoryId', item.id);
      sessionStorage.setItem('topicId', item.topicId);
      let params = {
        categoryId: item.id,
        topicId: item.topicId,
      };
      this.$router.push({
        name: 'productss',
        params: params,
      });
      let that = this;
      setTimeout(function () {
        that.$router.push({
          name: 'product',
          params: params,
        });
      }, 10);
    },
    childLinkToSolution(item) {
      sessionStorage.setItem('categoryId', item.id);
      sessionStorage.setItem('topicId', item.topicId);
      let params = {
        categoryId: item.id,
        topicId: item.topicId,
      };
      this.$router.push({
        name: 'solutions',
        params: params,
      });
      let that = this;
      setTimeout(function () {
        that.$router.push({
          name: 'solution',
          params: params,
        });
      }, 10);
    },
    enter(num, item) {
      // console.log(item, '这是啥');
      this.nowItem = item;
      this.show = num;
      // console.log(this.menuData);
      if (this.menuData[num].childNode) {
        this.menuChild = this.menuData[num].childNode;
        // console.log(this.menuChild);
      } else {
        this.menuChild = [];
      }
      // console.log(this.menuChild, '二级');
    },
    leave() {
      if (!this.isMobile) {
        this.show = 0;
      }
    },
    leaves() {
      if (!this.isMobile) {
        this.show = 0;
        this.menuChild = [];
      }
    },
    getSortData() {
      this.$api['ql/getNavigationList']({category: 0}).then(res => {
        this.menuData = res;
        // [this.menuData[0], this.menuData[1], this.menuData[2], this.menuData[3], this.menuData[4], this.menuData[5], this.menuData[6]] = [this.menuData[3], this.menuData[1], this.menuData[2], this.menuData[4], this.menuData[5], this.menuData[0], this.menuData[6]];
        // console.log(res, '这是我拿到的导航栏数据');
      });
    },
    getSysbaseinfo() {
      if (localStorage.getItem('sysbaseinfo')) {
        this.sysbaseinfo = JSON.parse(localStorage.getItem('sysbaseinfo'));
        // console.log(this.sysbaseinfo, '系统信息1');
      } else {
        this.$api['ql/getSysbaseinfo']().then(data => {
          let sysbaseinfo = data;
          localStorage.setItem('sysbaseinfo', JSON.stringify(sysbaseinfo));
          this.sysbaseinfo = sysbaseinfo;
          // console.log(this.sysbaseinfo, '系统信息2');
        });
      }
    },
    // 检测是否为移动设备
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  created() {
    // 所有程序运行前最先进行
    this.getSortData();
    // 添加设备检测
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  mounted() {
    this.getSysbaseinfo();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.checkMobile);
  }
};
</script>
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #23283a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  z-index: 1000;
}

.header-logo {
  height: 100%;
  display: flex;
  align-items: center;
}

.header-logo img {
  height: 100%;
  width: auto;
}

.header-nav {
  height: 100%;
}

.nav-list {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-item {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 10px;
}

.nav-link {
  color: #fff;
  text-decoration: none;
  padding: 0 15px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #1e90ff;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #23283a;
  min-width: 200px;
  opacity: 0.95;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 20px;
  width: 600px;
  transition: all 0.3s ease;
  z-index: 1001;
}

.product-menu,
.solution-menu {
  width: 600px;
}

.dropdown-content {
  width: 100%;
}

.menu-category {
  margin-bottom: 20px;
}

.category-title {
  color: #1e90ff;
  font-size: 15px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(30, 144, 255, 0.2);
  font-weight: 500;
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.category-item {
  margin: 0;
}

.category-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
  display: block;
  padding: 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);
  text-align: center;
}

.category-link:hover {
  color: #1e90ff;
  background: rgba(30, 144, 255, 0.1);
  transform: translateX(5px);
}

/* 移除不再需要的样式 */
.solutions-grid {
  display: none;
}

.solution-item {
  display: none;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .header {
    height: 50px;
    padding: 0 10px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  .header-logo {
    height: 40px;
    max-width: 40px;
    overflow: hidden;
    margin-right: 5px;
  }

  .header-logo img {
    height: 100%;
    object-fit: contain;
  }

  .header-nav {
    width: calc(100% - 50px);
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
  }

  .header-nav::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
  }

  .nav-list {
    justify-content: flex-start;
    min-width: max-content;
    padding-right: 15px;
  }

  .nav-item {
    margin: 0 5px;
    white-space: nowrap;
  }

  .nav-link {
    font-size: 12px;
    padding: 0 6px;
    white-space: nowrap;
  }

  .dropdown-menu {
    width: 90vw;
    left: 0;
    transform: none;
    padding: 12px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .product-menu,
  .solution-menu {
    width: 90vw;
  }

  .category-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .category-link {
    font-size: 12px;
    padding: 8px 5px;
  }
}

/* 增加更小屏幕的适配 */
@media screen and (max-width: 480px) {
  .header {
    padding: 0 5px;
  }

  .header-logo {
    max-width: 30px;
  }

  .nav-item {
    margin: 0 2px;
  }

  .nav-link {
    padding: 0 4px;
    font-size: 11px;
  }
}
/*!*动画下滑*!*/
/*.fade-enter-active  {animation: bounce-in 0s;}*/
/*.fade-leave-to{ animation: bounce-in 0s reverse;}*/

/*.fadeshort-enter-active  {animation: bounce-in-short 0s;}*/
/*.fadeshort-leave-to{ animation: bounce-in-short 0s reverse;}*/
/*@keyframes bounce-in { 0% {height: 0;opacity: 0;}*/
/*  100% {height: 200px;opacity: 1;} }*/
/*@keyframes bounce-in-short { 0% {height: 0;opacity: 0;}*/
/*  100% {height: 60px;opacity: 1;} }*/

.nav-link.active {
  color: #1e90ff;
}

/* 遮罩层，用于点击关闭下拉菜单 */
.overlay {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 999;
}

@media screen and (max-width: 768px) {
  .overlay {
    top: 50px;
    z-index: 1000;
  }

  .dropdown-menu {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    max-width: 100%;
    transform: none;
    border-radius: 0;
    z-index: 1001;
  }

  .product-menu,
  .solution-menu {
    width: 100%;
    z-index: 1001;
  }

  .category-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .category-link {
    position: relative;
    z-index: 1002;
  }
}
</style>

